import { editionNumber, editionRoman } from '@/lib/edition';
import { cn } from '@/lib/cn';
export function EditionBadge({ seed, className }: { seed: string; className?: string }) {
  return <span className={cn('edition-num text-[13px]', className)}>N° {editionRoman(editionNumber(seed))}</span>;
}
